import { useState, useEffect } from "react";

const useNewRutaVisitada = (ruta, onChangeRuta) => {
  const [rutaVisitada, setRutaVisitada] = useState(localStorage.getItem('rutaEnSesion') || '');

  // Función para almacenar la ruta actual bajo el nombre de ruta en sesión.
  const savedRuta = () => {
    if (ruta !== '') {
      localStorage.setItem('rutaEnSesion', ruta);
      setRutaVisitada(ruta); // Actualiza el estado de la ruta visitada
      //console.log('rutaAlmacenada', ruta)
    }
  };

  // Función para obtener la ruta en sesión desde el localStorage.
  const getRuta = () => {
    let rutaEnSesion = localStorage.getItem('rutaEnSesion');
    if (rutaEnSesion !== '') setRutaVisitada(rutaEnSesion);
    //console.log('rutaEnSesion', rutaEnSesion)
  };

  useEffect(() => {
    savedRuta();
    getRuta();
    onChangeRuta(rutaVisitada);
  }, [ruta]);

  return rutaVisitada;
};

export default useNewRutaVisitada;
